// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/LoadingScreen';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ru';
import { InterviewProvider } from 'contexts/InterviewContext';
import { SocketProvider } from 'contexts/SocketContext';
import { ViewportHeightProvider } from './components/ViewportHeightProvider';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <RtlLayout>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
            <InterviewProvider>
              <SocketProvider>
                <ViewportHeightProvider>
                  <GlobalStyles />
                  <ProgressBarStyle />
                  {/* <Settings /> */}
                  <ScrollToTop />
                  <Router />
                </ViewportHeightProvider>
              </SocketProvider>
            </InterviewProvider>
          </LocalizationProvider>
        </RtlLayout>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
